'use strict';

/**
 * Component for the image selection
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ImagesCollection = require('../../collections/images');
var ColidoModel = require('base/Colido.Model');
var LayoutView = require('base/Colido.LayoutView');
var AssetUploadListView = require('./asset-upload-list');
var ImageUploadListItemView = require('./image-selection-list-item'); //@todo file name
var AlbumModalLayout = require('modules/collection/modules/album/views/layout/modal');

var template = require('../../templates/components/field-images.hbs');

var ImagesComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    /**
     * Reference to the upload view
     * @type {EditModule.AssetUploadListView}
     */
    assetUploadView: null,

    regions: {
        'assetListRegion': '.assets-list-region',
    },

    ui: {
        'importFromPhotobox': '[data-action="import-photobox"]',
        'chooseFiles': '[data-action="choose-files"]',
        'takePicture': '[data-action="take-picture"]',
        'importFromDropbox': '[data-action="import-from-dropbox"]',
        'importFromDropboxLabel': '[data-action="import-from-dropbox"] span',
        'imageSize': '[name="image-resize"]',
    },

    events: {
        'click @ui.importFromPhotobox': 'importFromPhotobox',
        'click @ui.chooseFiles': 'chooseFiles',
        'click @ui.takePicture': 'takePicture',
        'click @ui.importFromDropbox': 'importFromDropbox',
    },

    childEvents: {
        'upload:started': 'onUploadStarted',
        'upload:progress': 'onUploadProgress',
        'upload:completed': 'onUploadCompleted',
        'upload:error': 'onUploadError',
        'upload:abort': 'onUploadAbort',
    },

    modelEvents: {
        'assetUpload': 'handleAssetUpload',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        var field = this.getOption('field');

        this.assetUploadView = new AssetUploadListView({
            collection: new ImagesCollection(),
            model: new ColidoModel(),
            field: field,
            childView: ImageUploadListItemView,
            settings: {
                allow: ['image/jpeg', 'image/png', 'image/gif', 'video/mp4'],
            },
        });
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        // this.assetUploadView.collection = new EditModule.ImagesCollection();
        // this.assetUploadView.model = new Colido.Model();
    },

    onRender: function() {
        var field = this.getOption('field');

        this.assetListRegion.show(this.assetUploadView);

        if (this.model.get(field.name).length > 0) {
            this.assetUploadView.collection.reset(this.model.get(field.name));
        }

        // imagesSize
        this.ui.imageSize.filter('[value="' + this.model.get('imagesSize') + '"]').prop('checked', true);

        this.updateDropboxLabel();
    },

    /**
     * Event for handling photobox import
     * @param {object} event The event object
     * @return {void}
     */
    importFromPhotobox: function(event) {
        App.vent.trigger('collection:albums:photobox:reload');
        App.vent.trigger('collection:albums:unused:reload');

        App.addModal(new AlbumModalLayout(), {
            onAfterClose: function(data) {
                if (data && data.images) {
                    this.photoboxPicturesSelected(data.images);
                }
            }.bind(this),
        });
    },

    /**
     * Is called, when pictures have been selected from the photobox
     * @param {Array}       images The array with the images
     * @private
     */
    photoboxPicturesSelected: function(images) {
        _.each(images, function(image) {
            this.assetUploadView.collection.add(image);
        }.bind(this));
    },

    /**
     * Event for handling file choose
     * @param {object} event The event object
     * @return {void}
     */
    chooseFiles: function(event) {
        event.preventDefault();

        if (typeof this.assetUploadView.hiddenInput === 'object') {
            this.assetUploadView.hiddenInput.click();
        } else {
            Messenger().info({
                message: 'Sorry, this function is not supported yet!',
            });
        }
    },

    /**
     * Event for handling to take a picture
     * @param {object} event The event object
     * @return {void}
     */
    takePicture: function(event) {
        event.preventDefault();

        if (typeof this.assetUploadView.hiddenInputSingle === 'object') {
            this.assetUploadView.hiddenInputSingle.click();
        } else {
            Messenger().info({
                message: 'Sorry, this function is not supported yet!',
            });
        }
    },

    /**
     * Is triggered, when the user presses on the import from dropbox button
     * @param {object} event The click event
     */
    importFromDropbox: function (event) {
        event.preventDefault();

        if (window.Dropbox && window.Dropbox.choose) {
            window.Dropbox.choose({
                multiselect: true,
                linkType: 'direct',
                success: function(files) {
                    this.assetUploadView.handleDropboxSelect(files);
                }.bind(this),
            });
        } else {
            this.loadDropboxScript();
        }
    },

    /**
     * Loads the dropbox script, when it's not already loaded
     */
    loadDropboxScript: function() {
        if (this.isDropboxLoaded()) {
            return;
        }

        var dropbox = $('<script />', {
            'type': 'text/javascript',
            'id': 'dropboxjs',
            'data-app-key': App.config.dropboxAppKey,
        });

        dropbox.on('load', function(){
            this.updateDropboxLabel();
        }.bind(this));

        $('body').append(dropbox);

        dropbox.attr('src', 'https://www.dropbox.com/static/api/2/dropins.js');

        this.updateDropboxLabel();
    },

    isDropboxLoaded: function() {
        return !!$('#dropboxjs').length;
    },

    /**
     * Returns the data of this component
     * @returns {object} The data object
     */
    getData: function() {
        var data = {};
        var field = this.getOption('field');

        data[field.name] = this.assetUploadView.collection.getSortedImageIds();
        data.imagesSize = this.ui.imageSize.filter(':checked').val(); //@todo make dynamic

        return data;
    },

    handleAssetUpload: function(fieldName, event) {
        var field = this.getOption('field');

        if (fieldName === field.name) {
            this.assetUploadView.$el.trigger('drop', event);
        }
    },

    /**
     * Bubbles up the upload start event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} formData  Attache formdata of the upload
     */
    onUploadStarted: function(childView, model, formData) {
        this.trigger('upload:started', childView, model, formData);
    },

    /**
     * Bubbles up the upload progress event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} event     The original event
     */
    onUploadProgress: function(childView, model, event) {
        this.trigger('upload:progress', childView, model, event);
    },

    /**
     * Bubbles up the upload completed event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} event     The original event
     */
    onUploadCompleted: function(childView, model, event) {
        this.trigger('upload:completed', childView, model, event);
    },

    /**
     * Bubbles up the upload error event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} event     The original event
     */
    onUploadError: function(childView, model, event) {
        this.trigger('upload:error', childView, model, event);
    },

    /**
     * Bubbles up the upload abort event
     * @param {object} childView The childview that first bubbled the event
     * @param {object} model     The corresponding model, that causes the event
     * @param {object} event     The original event
     */
    onUploadAbort: function(childView, model, event) {
        this.trigger('upload:abort', childView, model, event);
    },

    updateDropboxLabel: function() {
        var label = App.t('collection::edit:image-selection:button-enable-dropbox');
        if ($('#dropboxjs').length) {
            label = App.t('collection::edit:image-selection:button-loading-dropbox');
        }

        if (window.Dropbox) {
            label = App.t('collection::edit:image-selection:button-import-from-dropbox');
        }

        this.ui.importFromDropboxLabel.html(label);

        this.ui.importFromDropbox.toggleClass('dropbox-ready', this.isDropboxLoaded());
    },
});

module.exports = ImagesComponent;